import { useMemo } from "react";
import { useEntityListSubTree } from "@contember/binding";
const useTopLevelOptionAccessors = (desugaredOptionPath, treeRootId) => {
  const entityList = useMemo(
    () => ({ entities: desugaredOptionPath, ...desugaredOptionPath }),
    [desugaredOptionPath]
  );
  const subTreeData = useEntityListSubTree(entityList, treeRootId);
  return useMemo(() => Array.from(subTreeData), [subTreeData]);
};
export {
  useTopLevelOptionAccessors
};
//# sourceMappingURL=useTopLevelOptionAccessor.js.map
